module.exports = require("@wordpress/url");